module.exports = __webpack_public_path__ + "img/hexagon.1908e58f.svg";